export function gateValidate(gate){
    var result = true;

    result = validateId(gate.id);
    result = validateName(gate.name);    
    result = validateIsEntry(gate.is_entry);
    result = validateIsRfid(gate.is_rfid);
    result = validateWarehouse(gate.warehouse)
    
    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof customer === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateIsEntry(is_entry){
    if(typeof is_entry === 'boolean' || is_entry == null) return true;
    else return false;
}

function validateIsRfid(is_rfid){
    if(typeof is_rfid === 'boolean' || is_rfid == null) return true;
    else return false;
}

function validateWarehouse(warehouse){
    if(!Number.isInteger(warehouse.id)) return false;
    if(typeof warehouse.name !== 'string' || warehouse.name.trim() === '') return false;
    if(typeof warehouse.picking_required !== 'boolean') return false;

    return true;
}